/** Rodzaj paczki: edycja pozycji rezerwacji albo rezygnacja (`BookingChangeKind`). */
export enum BookingChangeKind {
  EDIT = 'EDIT',
  WITHDRAWAL = 'WITHDRAWAL',
}
